export default __webpack_public_path__ + "static/media/device_marker_blue.3b35bea2.svg";